<div class="d-flex align-items-center gap-3">
  <h6 class="mb-0" i18n>Booking Details</h6>
  <div class="flex-fill"></div>
  <ng-container *ngIf="!readonly && !(1 | isReadonlyRole)">
    <a
      *ngxPermissionsOnly="['canEditInquiry']"
      i18n-matTooltip
      matTooltip="Edit booking details"
      matTooltipPosition="above"
      (click)="onUpdateDetails()"
      class="btn btn-light"
    >
      <i class="cs-icon cs-icon-pencil"></i>
    </a>
  </ng-container>
</div>
<div class="info-list mt-3">
  <div class="info-list-item">
    <div class="icon text-indigo">
      <i class="cs-icon cs-icon-calendar-plus text-xl"></i>
    </div>
    <div>
      <div class="label" i18n>From</div>
      <div class="value">{{ details?.guestArrive | epochUTC : 'DD - MMM - YYYY' }}</div>
    </div>
  </div>
  <div class="info-list-item">
    <div class="icon text-indigo">
      <i class="cs-icon cs-icon-calendar-plus text-xl"></i>
    </div>
    <div>
      <div class="label" i18n>To</div>
      <div class="value">{{ details?.guestDepart | epochUTC : 'DD - MMM - YYYY' }}</div>
    </div>
  </div>
  <div class="info-list-item">
    <div class="icon text-success">
      <i class="cs-icon cs-icon-checkin text-xl"></i>
    </div>
    <div>
      <div class="label" i18n>Check-In</div>
      <div class="value">{{ details?.checkIn | epoch : 'h:mm A' }}</div>
    </div>
  </div>
  <div class="info-list-item">
    <div class="icon text-warning">
      <i class="cs-icon cs-icon-checkout text-xl"></i>
    </div>
    <div>
      <div class="label" i18n>Check-Out</div>
      <div class="value">{{ details?.checkOut | epoch : 'h:mm A' }}</div>
    </div>
  </div>
  <ng-container *ngIf="showTimeZoneSource">
    <div class="info-list-item" *ngIf="details?.timezone">
      <div class="icon text-danger">
        <i class="cs-icon cs-icon-globe text-xl"></i>
      </div>
      <div>
        <div class="label" i18n>Timezone</div>
        <div class="value">{{ details?.timezone }}</div>
      </div>
    </div>
    <div class="info-list-item">
      <div class="icon text-indigo">
        <i class="cs-icon cs-icon-source text-xl"></i>
      </div>
      <div>
        <div class="label" i18n>Source</div>
        <div class="value">{{ inquiry.sourceView || inquiry.inquirySource | startCase }}</div>
      </div>
    </div>
  </ng-container>
  <!-- TV4-6226: affiliate / referral id captured from the booking link -->
  <div class="info-list-item" *ngIf="inquiry?.attributes?.referral?.id">
    <div class="icon text-indigo">
      <i class="far fa-link text-xl"></i>
    </div>
    <div>
      <div class="label" i18n>Referral ID</div>
      <div class="value">{{ inquiry.attributes?.referral?.id }}</div>
    </div>
  </div>
  <div class="info-list-item">
    <div class="icon text-warning">
      <i class="cs-icon cs-icon-adult text-xl"></i>
    </div>
    <div>
      <div class="label" i18n>Adults</div>
      <div class="value">{{ details?.numAdults }}</div>
    </div>
  </div>
  <div class="info-list-item">
    <div class="icon text-info">
      <i class="cs-icon cs-icon-child text-xl"></i>
    </div>
    <div>
      <div class="label" i18n>Children</div>
      <div class="value">{{ details?.numChild }}</div>
    </div>
  </div>

  <ng-container *ngIf="isAirbnbAPIBooking">
    <div class="info-list-item">
      <div class="icon text-indigo">
        <i class="far fa-baby-carriage text-xl"></i>
      </div>
      <div>
        <div class="label" i18n>Infants</div>
        <div class="value">
          <div class="value">{{ details?.num_infants || 0 }}</div>
        </div>
      </div>
    </div>
    <div class="info-list-item">
      <div class="icon text-danger">
        <i class="far fa-dog-leashed text-xl"></i>
      </div>
      <div>
        <div class="label" i18n>Pets</div>
        <div class="value">
          <div class="value">{{ details?.num_pets || 0 }}</div>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="info-list-item">
    <div class="icon text-danger">
      <i class="cs-icon cs-icon-day text-xl"></i>
    </div>
    <div>
      <div class="label" i18n>Days</div>
      <div class="value">{{ details?.guestDepart | dateDiff : details?.guestArrive }}</div>
    </div>
  </div>
  <div class="info-list-item">
    <div class="icon text-info">
      <i class="cs-icon cs-icon-moon text-xl"></i>
    </div>
    <div>
      <div class="label" i18n>Nights</div>
      <div class="value">{{ details?.guestDepart | dateDiff : details?.guestArrive : 'nights' }}</div>
    </div>
  </div>
  <div class="info-list-item access-codes-item" *ngxPermissionsOnly="['canSeeAccessCodes']">
    <div class="icon text-info">
      <i class="far fa-hashtag-lock text-xl"></i>
    </div>
    <div>
      <div class="label" i18n>Access Code</div>
      <div class="value">
        <app-booking-access-code [inquiry]="inquiry" (link)="onLinkDevice()"></app-booking-access-code>
      </div>
    </div>
  </div>
</div>
